import React, { useState, useEffect,useRef } from 'react';
import {urlApiProd,print,correoUsuario,formatYYYYMMDD,capitalizeFirstLetter,handleEliminar,handleAgregar} from '../utiles';
import DateInput from '../../components/DateInput/DateInput';
import { Modal, Button, Spinner, Badge, Card,Form,Row,Alert,Table,Container,Col,InputGroup,Accordion,ListGroup } from 'react-bootstrap';
import moment from 'moment';
import { IoTrashOutline,IoDownloadOutline } from "react-icons/io5";
import { toast, ToastContainer } from 'react-toastify';
import DataTable from 'react-data-table-component';
import { LuPencilLine } from "react-icons/lu";


const EditarSolicitud = ({ solicitud, puertos, ffw, carriers, cerrar }) => {
const [formDataAntigua, setFormDataAntigua] = useState({ ...solicitud });
const [formData, setFormData] = useState({ ...solicitud });
const [show, setShow] = React.useState(true);
const [dataHistoria, setdataHistoria] = useState([]);
const [usuarioCreador, setUsuarioCreador] = React.useState(undefined);
const [mapa,setMAPA] = React.useState(solicitud.mapa);
const [erroresForm, seterroresForm] = useState('');
const [showguardarArchivo, setShowguardarArchivo] = React.useState(false);
const [dataDocumentos,setDocumentos] = useState([]);
const [dataClientes,setClientes] = useState([]);
const [dataClientesBooking,setClientesBooking] = useState([]);
const [dataProveedores,setProveedores] = useState([]);
const [DataBookingProveedores,setDataBookingProveedores] = useState([]);
const [loading, setLoading] = useState(true);
const [DataBookingProformas,setDataBookingProformas] = useState([]);
const [dataNombresProductos,setDataNombresProductos] = useState([]);
const [dataSolicitudInternaBkn,setSolicitudInternaBkn] = useState([]);

useEffect(() => {
    //fetchDataClientes();
    //fetchDataProveedores();
    //fetchDataNombreProductos();
    //fetchDataBookingProductos();
    //fetchDataClientesBooking();
    //fetchDataBookingProveedor();
    //fetchDataBookingProformas();
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    fetchSolicitudInterna();
    fetchDataDocumentos();
    fetchDataHistoria();
setLoading(false);

  };

  
  const fetchSolicitudInterna = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/solicitudinterna/${formData.solicitud_interna.id}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching fetchSolicitudInterna');
        const data = await response.json();
        setSolicitudInternaBkn(data.data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`fetchSolicitudInterna no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataNombreProductos = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/nombreproductos`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching fetchDataNombreProductos');
        const data = await response.json();
        setDataNombresProductos(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`fetchDataNombreProductos no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataBookingProformas = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingproforma/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching DataBookingProveedores');
        const data = await response.json();
        setDataBookingProformas(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`DataBookingProveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

  const fetchDataBookingProveedor = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingproveedores/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching DataBookingProveedores');
        const data = await response.json();
        setDataBookingProveedores(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`DataBookingProveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

const fetchDataProveedores = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/proveedores`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching proveedores');
        const data = await response.json();
        setProveedores(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`proveedores no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
};

const fetchDataClientesBooking = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/bookingclientesbooking/${formData.id_solicitud}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching bookingclientesbooking');
        const data = await response.json();
        setClientesBooking(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`bookingclientesbooking no cargados: ${error.message}`, { toastId: 'error-principal' });
    }
    
};

const fetchDataClientes = async () => {
    const token = localStorage.getItem('token');
    try {
        // Fetch Solicitudes Internas
        const response = await fetch(`${urlApiProd}/clientes`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error fetching clientes');
        const data = await response.json();
        setClientes(data);
    } catch (error) {
        console.error('Error en fetchData:', error.message);
        toast.error(`clientes no cargados: ${error.message}`, { toastId: 'error-principal' });
    } 
};
      
const handleCloseguardarArchivo = () => {
    fetchDataDocumentos();
    setShowguardarArchivo(false);};
const handleShowguardarArchivo = () => setShowguardarArchivo(true);

function timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
}

const handleUploadFileServer = async (e) => {
    const file = e.target.files[0];
    print(file);

    if(file.size<5000000){
        const token = localStorage.getItem('token');
    const fd = new FormData()
    fd.append('file', file)
    fd.append('nombre',file.name)
    fd.append('ruta','bookingexterno')
    fd.append('idObjeto',formData.id_solicitud)
    fd.append('usuario_creador',localStorage.getItem('ID_Usuario'))
    fd.append('mail_usuario_creador',localStorage.getItem('correo'))

    const response = await fetch(`${urlApiProd}/subirarchivo`, {
        headers: { 'Authorization': `Bearer ${token}` },
        method: "POST",
        body: fd
    });

    if (response.ok){
    var r = await response.json();
    print(`response ${JSON.stringify(r)}`);
    alert("Archivo guardado correctamente");
    fetchDataDocumentos();

    } else{
        print("error subiendo archivo");
    }
    
} else{
    alert("Archivo muy grande, favor comprimir o disminuir tamaño. Max 5MB");
}
        
}

const GuardarArchivo = () => {

        return (
          <>
            <Button variant="success"  style={{marginTop:5, width:200}} onClick={handleShowguardarArchivo}>
                    Documentación de Booking
             </Button>
      
            <Modal size='lg' show={showguardarArchivo} onHide={handleCloseguardarArchivo} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Documentación de Booking</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <DataTable
                                columns={columns}
                                data={dataDocumentos}
                                pagination
                                paginationPerPage={10}
                                highlightOnHover
                                responsive
                            />
                            <p></p>
              Cargar nuevo archivo          
              <input type="file" onChange={handleUploadFileServer} />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseguardarArchivo}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      };

          const fetchDataDocumentos = async () => {
              const token = localStorage.getItem('token');
              try {
                  // Fetch Solicitudes Internas
                  const responsedocumentos = await fetch(`${urlApiProd}/documentosbooking`, {
                      headers: { 'Authorization': `Bearer ${token}` }
                  });
                  if (!responsedocumentos.ok) throw new Error('Error fetching preciosfletes');
                  const data= await responsedocumentos.json();
                  setDocumentos(data);
              } catch (error) {
                  console.error('Error en fetchData:', error.message);
                  toast.error(`documentos no cargados: ${error.message}`, { toastId: 'error-principal' });
              } finally{return true;}
          };



const fetchDataHistoria = async () => {
    setUsuarioCreador(await correoUsuario(formData.id_creador));
            const token = localStorage.getItem('token');
            try {
                // Fetch Solicitudes Internas
                const response = await fetch(`${urlApiProd}/historias/booking/${formData.id_solicitud}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Error fetching datos hisotrias');
                const data= await response.json();
                data.reverse();
                //print(`'Edata:', ${data}`);
                setdataHistoria(data);
                //setTotalItems(total);
                //setPrincipal(true);
            } catch (error) {
                print(`'Error en fetchData:', ${error.message}`);
                //setPrincipal(false); // Indica que la solicitud principal falló
                print(`historias no cargadas: ${error.message} { toastId: 'error-principal' }`);
            }
        };

const handleDownloadFile = async (row) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${urlApiProd}/descargardocumento/${row.id}`, {
            method: 'POST',
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {throw new Error('Error descargando documento');}
        else {


            const buffer = await response.arrayBuffer();
            const bytes = new Uint8Array(buffer);
            const blob = new Blob([bytes]);
            const formatedURL = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = formatedURL;
            link.setAttribute('download',row.nombre);
            document.body.appendChild(link);
            link.click();

            //print(`descargado ok ${bytes}`);
        }

        //fetchDataDocumentos();
    } catch (error) {
        console.error('Error:', error);
        alert('No fue posible descargar documento');
    }
}

        const columns = [
            { name: 'Nombre', selector: row => row.nombre,  sortable: true,reorder: true },
            { name: 'Fecha Creación', selector: row => row.fecha_creacion ? formatYYYYMMDD(row.fecha_creacion) : '',  sortable: true,reorder: true },
            { name: 'Usuario Creador', selector: row => row.mail_usuario_creador,  sortable: true,reorder: true },
            { name: 'Acciones',
                        cell: row => (
                            <div >
                                 <button className='btn btn-outline-primary mr-2' onClick={() => handleDownloadFile(row)} style={{ flex: 1, marginRight: 10 }}>
                                                            <IoDownloadOutline />
                                                        </button>
                                    <button
                                        className='btn btn-outline-danger'
                                        onClick={() => {
                                            if (window.confirm('¿Estás seguro de eliminar documento?')) {
                                                handleEliminarDoc(row.id);
                                            }
                                        }} 
                                    >
                                        <IoTrashOutline />
                                    </button>
                                   
                            </div>
                        ),
                        ignoreRowClick: true,
                    }
        ];   
        
              const handleEliminarDoc = async (id) => {
                const token = localStorage.getItem('token');
                try {
                    const response = await fetch(`${urlApiProd}/eliminardocumentobooking/${id}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            usuario_elimina: localStorage.getItem('ID_Usuario')
                        }),

                    });
                    if (!response.ok) throw new Error('Error eliminando documento');
                    alert('Documento eliminado exitosamente');
                    fetchDataDocumentos();
                    return true;
                } catch (error) {
                    console.error('Error:', error);
                    alert('No se pudo eliminar documento');
                }
            };

    const handleClose = () => {setShow(false);
        cerrar();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        //print(`name ${name} value ${value} `);
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleChangeCantidad = (e, maxi) => {
        const { name, value,min,max } = e.target;
        var value1 = 0;

        if(Number(value)<Number(maxi)){
            value1 = Number(value);     
            setFormData({ ...formData, [name]: value1>0 ? Number(value1) : '' });
        }
    }

    const handleChangeCantidadInvoice = (e, maxi) => {
        const { name, value,min,max } = e.target;
        var value1 = 0;

        if(Number(value)<Number(maxi)){
            value1 = Number(value);     
            setFormData({ ...formData, [name]: value1>0 ? Number(value1) : '' });
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.codigo.trim() || formData.id_puerto_origen===-1 || formData.id_puerto_destino===-1 || !formData.etd || !formData.cantidad || !formData.flete || formData.id_carrier===-1) {
            // alert('Por favor, complete todos los campos obligatorios.');
             seterroresForm('⚠️ Favor revisar información ⚠️');
             await timeout(2000);
             seterroresForm('');
             return;
         }


         if(formData.dlc===''){
            formData.dlc=null;
      }
      if(formData.dld===''){
        formData.dld=null;
  }
  if(formData.eta===''){
    formData.eta=null;
}


        const token = localStorage.getItem('token');


       var tifOptions = [];

        Object.keys(formDataAntigua).forEach(function(key) {
            if(key!=='solicitud_interna' && formDataAntigua[key]!==formData[key])
                tifOptions.push("algo"); 
        });

        print(`tifOptions ${tifOptions.length}`);

     //if  
     if(tifOptions.length>0){
        //print(`esto se guarda; ${JSON.stringify(formData)}`);
        try {
            const response = await fetch(`${urlApiProd}/editsolicitudbooking/${solicitud.id_solicitud}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });


            if (response.ok){ 
                print(moment());
                print(JSON.stringify({tabla : 'booking', objeto_anterior : JSON.stringify(formDataAntigua), objeto_actual: JSON.stringify(formData), fecha: moment(), usuario_modifica: localStorage.getItem('correo'), usuario_modifica_id : localStorage.getItem('ID_Usuario'), id_objeto: formData.id_solicitud}));
                try {
                    const response1 = await fetch(`${urlApiProd}/add_historia`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({tabla : 'booking', objeto_anterior : JSON.stringify(formDataAntigua), objeto_actual: JSON.stringify(formData), fecha: moment(), usuario_modifica: localStorage.getItem('correo'), usuario_modifica_id : localStorage.getItem('ID_Usuario'), id_objeto: formData.id_solicitud})
                    });
        
        
                    if (response1.ok){ 
        
                        alert('Solicitud editada exitosamente');
        
                    } else { 

                    //throw new Error('Error al editar la solicitud');
                    alert('Error al crear historia');
                     }
        
        
                  
                } catch (error) {
                    console.error('Error:', error);
                }

                //print(`formData.estado.toString() ${formData.estado.toString()} ${formData.solicitud_interna.id.toString()} ${formData.solicitud_interna.id} ${JSON.stringify(dataSolicitudInternaBkn)}`);

                if(formDataAntigua.estado.toString()!=='2' && formData.estado.toString()==='2'){
                    formDataAntigua.estado=2;
                    //var solicitudInterna = solicitudesInternas.find((solicitud) => solicitud.id_solicitudinterna.toString() === formData.solicitud_interna.id.toString());
                    print(`dataSolicitudInternaBkn ${JSON.stringify(dataSolicitudInternaBkn)}`);
                    print(`solicitudInterna.cantidad_confirmada ${dataSolicitudInternaBkn.cantidad_confirmada} ,, formData.cantidad ${formData.cantidad}`);
                    dataSolicitudInternaBkn.cantidad_confirmada=formData.cantidad+dataSolicitudInternaBkn.cantidad_confirmada;
                    try {
                        const response2 = await fetch(`${urlApiProd}/modificarsolicitudinterna`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`
                            },
                            body: JSON.stringify(dataSolicitudInternaBkn)
                        });
                        if (!response2.ok) throw new Error('Error al modificar la solicitud interna');
                        //alert('Solicitud interna modificada exitosamente');
                     
                    } catch (error) {
                        print(`response ${error}`); 

                        alert('No se pudo modificar la solicitud interna');
                    }
                }

                cerrar({
                    actualizado: true,
                    estadoAnterior: formDataAntigua.estado,
                    estadoNuevo: formData.estado,
                });

            } else {
                const r = await response.json();
                print(`response ${r.error}`); 
            //throw new Error('Error al editar la solicitud');
            alert('Error al editar la solicitud');
             }


           // cerrar();
        } catch (error) {
            print(`response ${error}`); 
            alert('No se pudo editar la solicitud');
        }
    } else{
        seterroresForm('⚠️ No hay cambios realizados ⚠️');
        await timeout(2000);
        seterroresForm('');
    }

    };


    return (
        <Modal dialogClassName="my-modal" size='xl' aria-labelledby="contained-modal-title-vcenter"
        centered show={show} onHide={handleClose} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>{formData.nro_booking===null || formData.nro_booking==='' ? 'Gestión de Booking' : `Gestión de Booking N° ${formData.nro_booking}`}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              {loading  ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status" />
                                <span className="sr-only">Cargando...</span>
                            </div>
                        ) : ( <><Form onSubmit={handleSubmit}>         
                    
   <div className="container">
  <div className="row">
    <div className="col-3">
    <div className="mb-3">
                                <label className="form-label">Solicitud Interna Asociada</label>
                                <h4>{formData.solicitud_interna.codigo}</h4>
                            </div>
        </div>
        <div className="col-3">
        <div className="mb-3">
                                <label className="form-label">Estado de Booking {formData.estado.toString()==='0'? '🔴' : formData.estado.toString()==='1' ? '🟡' : formData.estado.toString()==='2' ? '🔵' : formData.estado.toString()==='3' ? '🟢' : formData.estado.toString()==='-1' ? '⚫' : formData.estado===99 ? '⚪' : ''}</label>
                                <select className="form-select" name="estado" onChange={handleChange} value={formData.estado}
                                 style={{backgroundColor:'black !important'}}>
                                    <option key="Pendiente" value="0">Pendiente</option>
                                    <option key="Solicitado" value="1">Solicitado</option>   
                                    <option key="Confirmado" value="2">Confirmado</option>

                                </select>
                            </div>
        </div>
     
<div className="col-3">
<div className="col text-center">
                            
                            <GuardarArchivo/>
                            </div>
                            </div>
                            <div className="col-3 text-center">
            <Button variant="primary" size="lg" onClick={handleSubmit} style={{marginTop:5}}>
                        Actualizar Booking
                        </Button>
                        <div>{erroresForm}</div>
</div>

       <p></p>
       <hr></hr>
        </div>
        <div className="row">
    <div className="col">         
    <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Referencia</label>
                                <input type="text" className="form-control" name="codigo" onChange={handleChangeUpperCase} value={formData.codigo}  required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label"  style={{fontWeight:'bold'}}>ETD</label>
                                <DateInput name="etd" onChange={handleChange} value={formData.etd} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">DLD</label>
                                <DateInput name="dld" onChange={handleChange} value={formData.dld} />
                            </div>
                            
                            <div className="mb-3">
                                <label className="form-label">FFW</label>
                                <select
                                    className="form-select"
                                    name="id_ffw"
                                    onChange={(e) => handleChange({ target: { name: "id_ffw", value: e.target.value || null } })}
                                    value={formData.id_ffw || ""}
                                >
                                    {ffw.map((item) => (
                                        <option key={item.id_ffw} value={item.id_ffw}>
                                            {item.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {formData.id_ffw === null || formData.id_ffw === "" ? (
                                <div className="mb-3">
                                    <label className="form-label">Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 2) // Filtra los carriers tipo 2
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            ) : (
                                <div className="mb-3">
                                    <label className="form-label" style={{fontWeight:'bold'}}>Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 1) // Filtra los carriers tipo 1
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            )}
                            <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Puerto Origen</label>
                                <select
                                    className="form-select"
                                    name="id_puerto_origen"
                                    onChange={handleChange}
                                    value={formData.id_puerto_origen}
                                >
                                    <option value="">Seleccione un Puerto</option>
                                    {puertos
                                        .filter((puerto) => puerto.indicador === 1 || puerto.indicador === 3) // Filtra puertos origen
                                        .map((item) => (
                                            <option key={item.id_puerto} value={item.id_puerto}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            
                            <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Free Time Origen</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftorigen"
                                    onChange={handleChange}
                                    value={formData.ftorigen}
                                    placeholder="Días"
                                    required
                                />
                            </div>
                          



    </div>
    
    <div className="col">
    <div className="mb-3">
                                <label className="form-label">N° Booking</label>
                                <input type="text" className="form-control" name="nro_booking" onChange={handleChange} value={formData.nro_booking} />
                            </div>
    <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Flete USD</label>
                                <input type="number" step="0.01" className="form-control" name="flete" onChange={handleChange} value={formData.flete} required />
                            </div>

    
                            <div className="mb-3">
                                <label className="form-label">DLC</label>
                                <DateInput name="dlc" onChange={handleChange} value={formData.dlc} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">ETA</label>
                                <DateInput name="eta" onChange={handleChange} value={formData.eta} />
                            </div>
                           
                            <div className="mb-3">
                                <label className="form-label">Nave</label>
                                <input type="text" defaultValue='' className="form-control" name="nave" onChange={handleChange} value={formData.nave} required />
                            </div>
                          <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Puerto Destino</label>
                                <select
                                    className="form-select"
                                    name="id_puerto_destino"
                                    onChange={handleChange}
                                    value={formData.id_puerto_destino}
                                >
                                    <option value="">Seleccione un Puerto</option>
                                    {puertos
                                        .filter((puerto) => puerto.indicador === 2 || puerto.indicador === 3) // Filtra puertos destino
                                        .map((item) => (
                                            <option key={item.id_puerto} value={item.id_puerto}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Free Time Destino </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftdestino"
                                    onChange={handleChange}
                                    value={formData.ftdestino}
                                    placeholder="Días"
                                    required
                                />
                            </div>
                          
                           
                          

    </div>
    <div className="col">

    <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Cantidad de Contenedores</label>
                                <input type="number" className="form-control" name="cantidad" onChange={(e) => handleChangeCantidad(e, 100)} value={formData.cantidad} min="1" maxlength="2"  required />
                            </div>
                           
                            

     <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Peso de Carga</label>
                                <input type='text' className="form-control" name="cargo_weight" onChange={handleChange} value={formData.cargo_weight} required/>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Tipo de Carga</label>
                                <select className="form-select" name="tipo_carga" onChange={handleChange} value={formData.tipo_carga}>
                                    <option value="40HC Supertestado">40HC Supertestado</option>
                                </select>
                            </div>


                            <div className="mb-3">
                                <label className="form-label">Tipo</label>
                                <select className="form-select" name="tipo_bl" onChange={handleChange} value={formData.tipo_bl}>
                                    <option key="BL Original" value="BL Original">
                                    BL Original  </option>
                                    <option key="Express Release" value="Express Release">
                                    Express Release
                                            </option>   

                                </select>
                            </div>
                        
                            <div className="mb-3">
                                <label className="form-label">Categoría</label>
                                <select className="form-select" name="categoria_booking" onChange={handleChange} value={formData.categoria_booking}>
                                <option value="">Seleccione categoría</option>
                                <option key="Lamina" value="1">
                                Lamina</option>  
                                <option key="Madera" value="2">
                                 Madera</option>
                                 <option key="Terciado" value="3">
                                 Terciado</option>   
                                    
                                </select>
                            </div>
    <div className="mb-3">
                                <label className="form-label">Requerimientos Especiales</label>
                                <textarea rows="6" className="form-control" name="requerimientos" onChange={handleChange} value={formData.requerimientos}></textarea>
                            </div>
    </div>

  </div>
        </div>
        </Form>

<p></p>
        <Accordion defaultActiveKey="-2">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Historia<Badge bg="danger" style={{marginLeft: 10}}>
                                            </Badge></Accordion.Header>
        <Accordion.Body>
        <Table striped bordered hover>
                                <tbody>
                                    <tr>
                                    <th>Usuario Creador</th>
                                    <th>Fecha Creación</th>
                                    </tr>
                                    <tr>
                                    <td>{usuarioCreador}</td>
                                    <td>{formData.fecha_creacion}</td>
                                    </tr>
                                    </tbody>
                                    </Table>
                                {dataHistoria.length>0 ? (<Table striped bordered hover>
                                    <tbody>
                                    <tr>
                                    <th>Usuario Actualiza</th>
                                    <th>Fecha</th>
                                    <th>Datos</th>
                                    </tr>
                             
                                    {dataHistoria.map((object, i) => <tr><td>{object.usuario_modifica.split('@')[0]}</td><td>{object.fecha}</td>
                                    <td>
                                    {Object.keys(object.objeto_anterior).map((key)=>{
                                                                             if(key!=='solicitud_interna' && object.objeto_anterior[key]!==object.objeto_actual[key])
                                                                                return (<div key={key}><b>{capitalizeFirstLetter(key.replace('_',' '))}</b><br></br>Antiguo: {(object.objeto_anterior[key]===null ? 'sin dato' : object.objeto_anterior[key]===true ? 'activado' : object.objeto_anterior[key]===false ? 'desactivado' : key==='estado' ? (object.objeto_anterior[key].toString()==="0" ? 'Pendiente' : object.objeto_anterior[key].toString()==="1" ? 'Solicitado' : object.objeto_anterior[key].toString()==="2" ? 'Confirmado' : object.objeto_anterior[key].toString()==="3" ? 'Embarcado' : object.objeto_anterior[key].toString()==="-1" ? 'Cancelado' : object.objeto_anterior[key].toString()==="99" ? 'Transferencia' : 'Sin estado') : key==='categoria_booking' ? (object.objeto_anterior[key].toString()==="1" ? 'Lamina' : object.objeto_anterior[key].toString()==="2" ? 'Madera' : object.objeto_anterior[key].toString()==="3" ? 'Terciado' : 'Sin categoria') : key==='id_ffw' ? (ffw.find(f => f.id_ffw.toString() === object.objeto_anterior[key].toString())?.nombre || '') : key==='id_carrier' ? (carriers.find(f => f.id_carrier.toString() === object.objeto_anterior[key].toString())?.nombre || '') : object.objeto_anterior[key])+""} , Nuevo: {(object.objeto_actual[key]===null ? 'sin dato' : object.objeto_actual[key]===true ? 'activado' : object.objeto_actual[key]===false ? 'desactivado' : key==='estado' ? (object.objeto_actual[key].toString()==="0" ? 'Pendiente' : object.objeto_actual[key].toString()==="1" ? 'Solicitado' : object.objeto_actual[key].toString()==="2" ? 'Confirmado' : object.objeto_actual[key].toString()==="3" ? 'Embarcado' : object.objeto_actual[key].toString()==="-1" ? 'Cancelado' : object.objeto_actual[key].toString()==="99" ? 'Transferencia' : 'Sin estado') : key==='categoria_booking' ? (object.objeto_actual[key].toString()==="1" ? 'Lamina' : object.objeto_actual[key].toString()==="2" ? 'Madera' : object.objeto_actual[key].toString()==="3" ? 'Terciado' : 'Sin categoria') : key==='id_ffw' ? (ffw.find(f => f.id_ffw.toString() === object.objeto_actual[key].toString())?.nombre || '') : key==='id_carrier' ? (carriers.find(f => f.id_carrier.toString() === object.objeto_actual[key].toString())?.nombre || '') : object.objeto_actual[key])+""}</div>);
                                                                        })}
                                    </td>
                                        </tr>)}

                                    </tbody>
                               </Table>) : (<></>) }
                               
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>

      </>)}      
                 


              </Modal.Body>
            </Modal>
    );
};

export default EditarSolicitud;
